var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Modal from "react-modal";
import { useEffect, useRef, useState } from "react";
import { env, iframeModalStyles } from "../../constants/global.constants";
import "./credit.card.form.css";
import { useForm } from "react-hook-form";
import { api, ApiService } from "../../services/http.service";
import { auth } from "../../store/auth.store";
import { cartStore, creditCartSubject } from "../../store/cart.store";
import { modalServiceSubject } from "../../services/modal.service";
import { v4 as uuid } from "uuid";
import InputMask from "react-input-mask";
import { sha512 } from "js-sha512";
export function CreditCardForm(props) {
    var _a;
    var setShowCCForm = props.setShowCCForm;
    var showCCForm = props.showCCForm;
    var isGame = (_a = props.isGame) !== null && _a !== void 0 ? _a : false;
    var _b = useState(false), saveCard = _b[0], setSaveCard = _b[1];
    var _c = useState(null), savedCards = _c[0], setSavedCards = _c[1];
    var _d = useState(null), selectedCard = _d[0], setSelectedCard = _d[1];
    var _e = useState(1), selectedTab = _e[0], setSelectedTab = _e[1];
    var _f = useState(null), errorMessage = _f[0], setErrorMessage = _f[1];
    var _g = useState(false), show3DiFrame = _g[0], setShow3DiFrame = _g[1];
    var paymentRef = useRef(null);
    useEffect(function () {
        var creditCartSubject_subscriber = creditCartSubject.subscribe(function (res) {
            if (res && res.status) {
                if (res.status === "success") {
                    setShowCCForm(false);
                    setShow3DiFrame(false);
                    setErrorMessage(null);
                }
                else {
                    setShowCCForm(false);
                    setShow3DiFrame(false);
                    setErrorMessage(null);
                    modalServiceSubject.next({
                        case: "danger",
                        title: "İşlem Başarısız!",
                        content: "<p class=\"text-center\">L\u00FCtfen bilgilerinizi tekrar kontrol ediniz ve daha sonra tekrar deneyiniz. <br />".concat(res.message ? res.message : "", "</p>"),
                        confirm: {
                            cancel: {
                                class: "btn-danger",
                                label: "Tamam",
                            },
                        },
                    });
                }
            }
        });
        return function () {
            creditCartSubject_subscriber.unsubscribe();
        };
    }, []);
    useEffect(function () {
        if (auth.authentication && auth.member && auth.member.id) {
            api.start("get", env.accounting_api + "/pos/api/list-member-cards/", null, true).then(function (res) {
                if (res && res.status && res.data) {
                    setSavedCards(res.data);
                    if (res.data.length === 0) {
                        setSelectedTab(1);
                    }
                }
            });
        }
    }, [auth.member]);
    var _h = useForm(), register = _h.register, handleSubmit = _h.handleSubmit, reset = _h.reset, errors = _h.formState.errors;
    var onSubmit = function (formData) {
        var payload = null;
        if (selectedTab === 1) {
            var orderPayload = {
                unit: cartStore.pointUsage === false ? "0" : "2",
                discount_coupon_code: cartStore.couponCode ? cartStore.couponCode.code : null,
                agreement: cartStore.agreement === true ? 'true' : 'false',
                ticket: cartStore.items.map(function (el) {
                    return { draw_no: el.item.no.toString(), multiply: el.quantity.toString() };
                }),
            };
            // payload = {
            //   request_id: uuid(),
            //   ccno: formData.creditCardNumber.replaceAll(" ", ""),
            //   expm: formData.creditExpirationMonth,
            //   expy:
            //     formData.creditExpirationYear.length === 2
            //       ? "20" + formData.creditExpirationYear
            //       : formData.creditExpirationYear,
            //   cvv: formData.creditCardSecurityCode,
            //   amount: cartStore.total,
            //   save_card: saveCard ? 1 : 0,
            //   card_label: formData.card_label,
            //   order: orderPayload,
            // };
            if (isGame) {
                payload = {
                    request_id: uuid(),
                    ccno: formData.creditCardNumber.replaceAll(" ", ""),
                    expm: formData.creditExpirationMonth,
                    expy: formData.creditExpirationYear.length === 2
                        ? "20" + formData.creditExpirationYear
                        : formData.creditExpirationYear,
                    cvv: formData.creditCardSecurityCode,
                    amount: formData.amount,
                    save_card: saveCard ? 1 : 0,
                    card_label: formData.card_label,
                    card_holder: formData.card_holder,
                };
            }
            else {
                payload = {
                    request_id: uuid(),
                    ccno: formData.creditCardNumber.replaceAll(" ", ""),
                    expm: formData.creditExpirationMonth,
                    expy: formData.creditExpirationYear.length === 2
                        ? "20" + formData.creditExpirationYear
                        : formData.creditExpirationYear,
                    cvv: formData.creditCardSecurityCode,
                    amount: cartStore.total,
                    save_card: saveCard ? 1 : 0,
                    card_label: formData.card_label,
                    card_holder: formData.card_holder,
                    order: orderPayload,
                    agreement: cartStore.agreement,
                };
            }
        }
        else {
            if (selectedCard === null) {
                setErrorMessage("Lütfen kayıtlı kartlarınızdan birini seçin yada yeni bir kart bilgisi girerek işleminize devam edin.");
            }
            payload = {
                ccno: selectedCard,
                amount: cartStore.total,
            };
        }
        api
            .start("post", env.accounting_api + "/pos/api/create-transaction-request/", payload, true)
            .then(function (res) {
            // console.log(res)
            if (res && res.status) {
                var hash = sha512("".concat(res.data, "wcwlqe7leIu7hbmDYofV8uaRdQtaB0"));
                setShow3DiFrame(env.accounting_api);
                var formData_1 = new FormData();
                var data = { code: res.data, digest: hash };
                Object.entries(data).forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    formData_1.append(key, value);
                });
                var post = new ApiService();
                post.setHeaders({ "Content-Type": "multipart/form-data" });
                post.start("post", env.accounting_api + "/pos/api/create-transaction/", formData_1, true).then(function (res) {
                    var iframe = document.createElement("iframe");
                    // @ts-ignore
                    document.getElementById("paymentScript").appendChild(iframe);
                    iframe.setAttribute("style", "height:100%;width:100%;");
                    // @ts-ignore
                    iframe.contentWindow.document.open();
                    // @ts-ignore
                    iframe.contentWindow.document.write(res);
                    // @ts-ignore
                    iframe.contentWindow.document.close();
                });
            }
            else if (res.message) {
                setErrorMessage(res.message);
            }
        })
            .catch(function (e) {
            setErrorMessage(e);
        });
    };
    var cardSelectionChangeHandle = function (e) {
        setSelectedCard(e.id);
    };
    var tabChangeHandler = function (e) {
        // console.log(e)
        setSelectedTab(e);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Modal, __assign({ isOpen: showCCForm, onRequestClose: function () {
                    setShowCCForm(false);
                }, style: {
                    content: {
                        top: "50%",
                        left: "50%",
                        right: "auto",
                        bottom: "auto",
                        marginRight: "-50%",
                        maxWidth: "calc(100vw - 80px)",
                        width: "460px",
                        height: "480px",
                        maxHeight: "calc(100% - 100px)",
                        padding: "0",
                        transform: "translate(-50%, -50%)",
                        background: "var(--bs-white)",
                    },
                } }, { children: _jsxs("div", __assign({ className: "credit-card-form pb-5" }, { children: [_jsx("h2", { children: "Kredi Kart\u0131" }), _jsx("p", { children: "Sepetinizdeki biletleri kart\u0131n\u0131z ile veya hesab\u0131n\u0131zdaki bakiye ile sat\u0131n alabilirsiniz." }), errorMessage && _jsx("p", __assign({ className: "alert alert-danger p-3 text-center" }, { children: errorMessage })), _jsxs("form", __assign({ onSubmit: handleSubmit(onSubmit), className: "mb-5" }, { children: [selectedTab === 0 ? (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "pb-3" }, { children: savedCards ? (_jsx(_Fragment, { children: savedCards.map(function (card, cKey) {
                                                return (_jsxs("div", __assign({ className: "form-check saved-card " + (selectedCard === card.id ? "selected" : "") }, { children: [_jsx("input", { className: "form-check-input", value: card.id, onChange: function () {
                                                                cardSelectionChangeHandle(card);
                                                            }, type: "radio" }), _jsxs("label", __assign({ className: "form-check-label fw-normal", htmlFor: "id_selectedCard" }, { children: [card.card_label, card.cart_label] })), _jsxs("div", __assign({ className: "bin-number" }, { children: [card.bin_number, "** ****"] }))] }), "saved-card-".concat(cKey)));
                                            }) })) : (_jsx(_Fragment, { children: _jsxs("p", __assign({ className: "mt-4 text-center" }, { children: ["Kay\u0131tl\u0131 kredi kart\u0131n\u0131z yok! ", _jsx("br", {}), "Yeni Kart sekmedinden i\u015Fleminize devam edebilirsiniz."] })) })) })) })) : (_jsx(_Fragment, {})), selectedTab === 1 ? (_jsxs(_Fragment, { children: [isGame && (_jsxs("div", __assign({ className: "mt-3" }, { children: [_jsx("label", __assign({ className: "form-label fw-bold mb-1" }, { children: "\u00C7ekilecek Tutar" })), _jsxs("div", __assign({ className: "input-group" }, { children: [_jsx("input", __assign({ type: "number", pattern: "\\d*", className: "form-control", placeholder: "0.00" }, register("amount", { required: true }), { step: 0.01 })), _jsx("span", __assign({ className: "input-group-text" }, { children: "TL" }))] })), _jsx("div", { className: "clearfix" }), errors.amount && _jsx("span", __assign({ className: "text-danger" }, { children: "L\u00FCtfen ge\u00E7erli bir miktar giriniz." }))] }))), _jsxs("div", __assign({ className: "row mt-3 mb-2" }, { children: [_jsxs("div", { children: [_jsx("label", __assign({ className: "form-label fw-bold mb-1" }, { children: "Kart \u00DCzerindeki \u0130sim" })), _jsx("div", __assign({ className: "input-group" }, { children: _jsx("input", __assign({ type: "text", placeholder: "Kart sahibinin ad\u0131 ve soyad\u0131", className: "form-control" }, register("card_holder", { required: true }))) })), _jsx("div", { className: "clearfix" }), errors.card_holder && (_jsx("span", __assign({ className: "text-danger" }, { children: "L\u00FCtfen kart \u00FCzerinde bulunan ad, soyad bilgisini giriniz.." })))] }), _jsxs("div", __assign({ className: "col-12" }, { children: [_jsx("label", __assign({ htmlFor: "id_creditCardNumber", className: "form-label" }, { children: "Kart Numaras\u0131" })), _jsx(InputMask, __assign({ mask: "9999 9999 9999 9999", autoComplete: "cc-number", "data-uia": "field-creditCardNumber", className: "form-control" }, register("creditCardNumber", { required: true }), { id: "id_creditCardNumber" })), errors.creditCardNumber && (_jsx("div", __assign({ className: "form-text text-danger" }, { children: "Kredi kart\u0131n\u0131z\u0131n \u00FCzerindeki 16 haneli numara." })))] }))] })), _jsxs("div", __assign({ className: "row mb-2" }, { children: [_jsxs("div", __assign({ className: "col-3 pe-1" }, { children: [_jsx("label", __assign({ htmlFor: "id_creditExpirationMonth", className: "form-label text-nowrap" }, { children: "Son Kullan\u0131m" })), _jsx(InputMask, __assign({ mask: "99", placeholder: "AA", autoComplete: "cc-exp-month", "x-autocompletetype": "cc-exp-month", "data-uia": "field-creditExpirationMonth", className: "form-control" }, register("creditExpirationMonth", { required: true }), { id: "id_creditExpirationMonth" })), errors.creditExpirationMonth && (_jsx("div", __assign({ className: "form-text text-danger" }, { children: "Son kullan\u0131m tarihini AA format\u0131nda giriniz. \u00D6r: 05" })))] })), _jsxs("div", __assign({ className: "col-3 ps-1" }, { children: [_jsx("label", __assign({ htmlFor: "id_creditExpirationYear", className: "form-label px-1" }, { children: "Tarihi" })), _jsx(InputMask, __assign({ mask: "9999", placeholder: "YYYY", "x-autocompletetype": "cc-exp-year", autoComplete: "cc-exp-year", "data-uia": "field-creditExpirationYear", className: "form-control" }, register("creditExpirationYear", { required: true }), { id: "id_creditExpirationYear" })), errors.creditExpirationYear && (_jsx("div", __assign({ className: "form-text text-danger" }, { children: "Son kullan\u0131m tarihini YYYY format\u0131nda giriniz. \u00D6r: 2023" })))] })), _jsxs("div", __assign({ className: "col-6" }, { children: [_jsx("label", __assign({ htmlFor: "id_creditCardSecurityCode", className: "form-label" }, { children: "CVV kodu" })), _jsx(InputMask, __assign({ mask: "999", autoComplete: "cc-csc", "data-uia": "field-creditCardSecurityCode", className: "form-control" }, register("creditCardSecurityCode", {
                                                            required: true,
                                                        }), { id: "id_creditCardSecurityCode" })), errors.creditCardSecurityCode && (_jsx("div", __assign({ className: "form-text text-danger" }, { children: "L\u00FCtfen g\u00FCvenlik kodunu (CVV) girin." })))] }))] }))] })) : (_jsx(_Fragment, {})), _jsx("div", __assign({ className: "row mb-4 pb-4" }, { children: _jsx("i", __assign({ className: "text-secondary" }, { children: "Kredi kart\u0131 \u00F6demelerinde iade kredi kart\u0131na yap\u0131l\u0131r ve bir sonraki hesap kesiminizde kart\u0131n\u0131za yans\u0131t\u0131l\u0131r." })) })), _jsxs("div", __assign({ className: "modal-ticket-footer credit-card-form-footer text-end" }, { children: [_jsx("div", { className: "wave" }), _jsxs("div", __assign({ className: "body-row row" }, { children: [_jsx("div", __assign({ className: "col-6 pe-0" }, { children: _jsx("button", __assign({ type: "button", onClick: function () {
                                                            setShowCCForm(false);
                                                        }, className: "btn w-100 me-2 custom-btn-danger" }, { children: "Vazge\u00E7" })) })), _jsx("div", __assign({ className: "col-6 ps-0" }, { children: _jsx("button", __assign({ id: "doneButton", className: "btn  w-100 btn-success" }, { children: "\u00D6deme Yap" })) }))] }))] }))] }))] })) })), _jsx(Modal, __assign({ isOpen: show3DiFrame !== false, onRequestClose: function () {
                    // setShow3DiFrame(false);
                }, style: iframeModalStyles }, { children: _jsx("div", { style: { height: "100%" }, id: "paymentScript", ref: paymentRef }) }))] }));
}
